import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/GeneralExceptions/";

export function logGeneralException(exception) {
    return apiUtils
      .post(
        `${baseUrl}LogException`,
        exception
      )
      .then(apiUtils.handleResponse)
      .catch(apiUtils.handleError);
  }